import { render } from "./SectionContentList.vue?vue&type=template&id=0813629c&scoped=true"
import script from "../js/section-content-list.js?vue&type=script&lang=js"
export * from "../js/section-content-list.js?vue&type=script&lang=js"

import "./SectionContentList.vue?vue&type=style&index=0&id=0813629c&scoped=true&lang=css"

import exportComponent from "/Users/mdmahamudurzamanbhuyan/Sites/localhost/disposhop_jars/dispo_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0813629c"]])

export default __exports__